<template>
  <a
    v-if="href"
    :class="componentClasses"
    :href="href"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
      <Icon
        v-if="iconAfter"
        class="stk-button-icon-after"
        :icon="iconAfter"
      />
    </div>
  </a>
  <router-link
    v-else-if="to"
    :class="componentClasses"
    :to="to"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
      <Icon
        v-if="iconAfter"
        class="stk-button-icon-after"
        :icon="iconAfter"
      />
    </div>
  </router-link>
  <button
    v-else
    :class="componentClasses"
    @click="$emit('click', $event)"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
      <Icon
        v-if="iconAfter"
        class="stk-button-icon-after"
        :icon="iconAfter"
      />
    </div>
  </button>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  to: {
    type: Object,
    default: null,
  },
  href: {
    type: String,
    default: '',
  },
  iconBefore: {
    type: String,
    default: '',
  },
  iconAfter: {
    type: String,
    default: '',
  },
  underlined: {
    type: Boolean,
  },
  noUnderline: {
    type: Boolean,
  },
  size: {
    type: String,
    default: '',
  },
});

const componentClasses = computed(() => [
  'stk-link',
  props.href ? `has-href` : '',
  props.size ? `stk-size-${props.size}` : '',
  props.underlined ? `with-line` : '',
  props.noUnderline ? `no-underline` : '',
]);
</script>

<style>
.stk-link {
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  vertical-align: top;

  &.with-line,
  &:hover {
    .stk-link-slot::after {
      transform: none;
    }
  }

  &.no-underline .stk-link-slot::after  {
    display: none;
  }
}

.stk-link-slot {
  position: relative;

  &::after {
    background-color: currentColor;
    content: "";
    height: 1px;
    position: absolute;
    top: 100%;
    left: 0;
    transition-duration: calc(2 * var(--stk-transition-duration));
    transition-property: transform;
    transform: scaleX(0);
    transform-origin: left center;
    width: 100%;
  }
}
</style>
